import { styled } from 'linaria/react';

import { COLORS, FONTS } from './constants';
import { FIXED_GLOBAL_ERROR_CSS_CLASS } from '../helpers/errorHandler';

const StyledGlobalStyle = styled.div`
  :global() {
    html {
      --keyboard-offset: 0px;
      --safe-area-top: env(safe-area-inset-top, 0px);
      --safe-area-bottom: env(safe-area-inset-bottom, 0px);
      --safe-area-left: env(safe-area-inset-left, 0px);
      --safe-area-right: env(safe-area-inset-right, 0px);
      margin: 0;
      overflow: auto;
      box-sizing: border-box;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior-x: none;
      font-family: ${FONTS.primary};
      font-size: 16px;
    }

    *,
    *:before,
    *:after {
      box-sizing: border-box;
      -webkit-tap-highlight-color: ${COLORS.transparent};
    }

    body {
      margin: 0;
      scroll-behavior: smooth;
      text-rendering: optimizeSpeed;
      width: 100%;
      min-height: 100dvh;
      background-attachment: fixed;
      &::-webkit-scrollbar {
        width: 0;
        background: ${COLORS.transparent};
      }
    }

    .disable-user-action {
      a {
        pointer-events: none !important;
        user-select: none !important;
        -webkit-touch-callout: none !important;
        touch-action: none !important;
      }

      .collection-preview-anchor,
      .link-preview-anchor,
      .guestSeries-preview-anchor,
      .thought-preview-anchor {
        display: block;
      }
    }

    ol,
    ul {
      padding: 0;
    }

    .fixed,
    .${FIXED_GLOBAL_ERROR_CSS_CLASS} {
      position: fixed;
      overflow: hidden;
      overscroll-behavior: none;
    }

    .reaction-menu-open {
      position: fixed;
      overflow: hidden;
      width: 100vw;
      height: 100vh;
      touch-action: none;
    }

    .dark {
      background: linear-gradient(180deg, #331500 0%, #141400 10%, #141400 90%, #0a0033 100%);
    }

    .light {
      background: linear-gradient(180deg, #ffeee8 0%, #f7f6f3 10%, #f7f6f3 90%, #ece8ff 100%), #fff;
    }

    .half-transparent {
      opacity: 0.5;
      transition: opacity 0.2s ease-in-out;
    }

    .hidden {
      visibility: hidden;
    }

    .removed {
      display: none;
    }

    .message.message-swiped {
      &::after {
        opacity: 1;
      }
    }

    .message-right.message-swiped {
      transform: translateX(-84px);
    }

    button {
      outline: none;
    }

    /* Debug mode: disable all animations for DOM inspection */
    .no-animations,
    .no-animations *,
    .no-animations *::before,
    .no-animations *::after {
      animation-duration: 0s !important;
      animation-delay: 0s !important;
      transition-duration: 0s !important;
      transition-delay: 0s !important;
      animation-play-state: paused !important;
    }
  }
`;

export default StyledGlobalStyle;
